module.exports = __webpack_public_path__ + "img/hngxy.80587a69.png";